define('helperLayout-setImagesSource',['helperLayout-setSvgTexts', 'jquery', 'lodash'], function(setSvgTexts, $, _) {
    'use strict';

    var setImagesSource = function(images, target) {
        var converterEngine = function (input) { // fn BLOB => Binary => Base64 ?
                var uInt8Array = new Uint8Array(input.response),
                    i = uInt8Array.length;
                var biStr = []; //new Array(i);
                while (i--) { biStr[i] = String.fromCharCode(uInt8Array[i]);  }
                var base64 = window.btoa(biStr.join(''));
                return [base64, input.getResponseHeader('content-type')];
            },
            getImageBase64 = function (url, callback, scope) {
                // to comment better
                var xhr = new XMLHttpRequest(url),
                    img64;
                xhr.open('GET', url, true); // url is the url of a PNG/JPG image.
                xhr.responseType = 'arraybuffer';
                xhr.callback = callback;
                xhr.onload  = function(){
                    img64 = converterEngine(this); // convert BLOB to base64
                    this.callback.call(scope, null, img64) // callback : err, data
                };
                xhr.onerror = function(){ callback('B64 ERROR', null); };
                xhr.send();
            },
            onEmbeddedBitmapLoaded = function (err, data) {
                if(!err) {
                    var s = window.Snap(this);
                    if(data[1].indexOf("image/")) data[1] = "image/png";
                    if (s) {
                        s.attr("xlink:href", "data:"+data[1]+";base64," + data[0]);

                        var $svg = $(this);
                        $svg.removeAttr('data-svg-id');
                    }
                }else{
                    console.error(err);
                }
            },
            setSource = function(sources, target) {
                var images;
                if(target && (typeof target.selectAll === 'function')){
                    images = target.selectAll('#player [data-img-id]');
                }else{
                    images = document.querySelectorAll('#player [data-img-id]');
                }

                for (var i = 0; i < images.length; i++) {
                    var image = (target) ? images[i].node: images[i],
                        id = image.getAttribute('data-img-id');

                    if(id) {
                        var media = _.find(sources, {'id': id});
                        if (!media) return;

                        var source = media.source;

                        if (image.nodeName == "image") {
                            // This is not supported in IE9
                            getImageBase64(source, onEmbeddedBitmapLoaded, images[i]);

                        } else {
                            var attrName = "src"; //(image.nodeName == "image") ? 'href' : 'src';
                            image.setAttribute(attrName, source);
                            image.removeAttribute('data-img-id');
                        }
                    }
                }
            },
            onSVGLoaded = function(data) {
                var s = window.Snap(this);

                if (s) {
                    if(data.node.parentElement == null){    // loaded
                        s.append(data);
                    }else{                                  // offline
                        s.append(data);
                    }
                    var $svg = $(this);
                    var svgs = $svg.has('text[data-text-id]');

                    setSvgTexts(svgs, window.viewModel);

                    $svg.removeAttr('data-svg-id');
                    $svg.removeAttr('data-img-loading');
                }
                setSource(images, s);
            },
            setInlineSVG = function(ID, source) {
                var images = document.querySelectorAll('[data-svg-id='+ ID +']:not([data-img-loading])');

                if (images && images.length) {
                    for(var i = 0; i < images.length; i++) {
                        images[i].setAttribute("data-img-loading", "true");

                        if(window.viewModel && window.viewModel.training && window.viewModel.training.dataContext.svgsInIndexHtml == true) {
                            // Offline
                            var filename = source.split("/").pop().split("?").shift();

                            var paper = window.Snap.parse(window.offlineSVGs[filename]);
                            if (paper) {
                                //var data = paper.outerSVG();
                                onSVGLoaded.call(images[i], paper);
                            }
                        }else{
                            // Online
                            window.Snap.load(source, onSVGLoaded, images[i]);
                        }
                    }
                }
            },
            setBackground = function(ID, source) {
                var divs = document.querySelectorAll('[data-bg-id='+ ID +']');

                if (divs && divs.length) {
                    for(var i = 0; i < divs.length; i++) {
                        divs[i].style.backgroundImage = 'url("' + source + '")';
                        divs[i].removeAttribute("data-bg-id");
                    }
                }
            };

        if (!images || !images.length) {
            return;
        }

        function setSources(){
            setSource(images, target);

            if(!target){
                for (var i = 0; i < images.length; i++) {

                    var source = images[i].source,
                        id = images[i].id,
                        image = document.getElementById(id);

                    if (image) {
                        image.setAttribute('src', source);
                    }
                    if (id && source) {
                        setInlineSVG(id, source);
                        setBackground(id, source);
                    }
                }
            }
        }

        setSources();
        setTimeout(setSources, 50);     // this is needed at least for images in body text when revisiting a page (GP-891)
        setTimeout(setSources, 300);    // for just in case
    };

    return setImagesSource;
});

